import {createSlice, createSelector} from '@reduxjs/toolkit';

const initialState = {
  type: '',
  message: '',
  time: new Date().toLocaleDateString("en-US"),
};

export const snackbar = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    infoSnack: (state, action) => {
      state.type = 'info';
      state.message = action.payload;
  state.time = new Date().toLocaleDateString("en-US");

    },
    successSnack: (state, action) => {
      state.type = 'success';
      state.message = action.payload;
  state.time = new Date().toLocaleDateString("en-US");

    },
    errorSnack: (state, action) => {
      state.type = 'error';
      state.message = action.payload;
  state.time = new Date().toLocaleDateString("en-US");

    },
    resetSnack: (state, action) => {
      state.type = '';
      state.message = '';
  state.time = new Date().toLocaleDateString("en-US");

    },
  },
});

// Action creators are generated for each case reducer function
export const {infoSnack, successSnack, errorSnack, resetSnack} =
  snackbar.actions;

export default snackbar.reducer;

export const selectSnackbar = createSelector(
  (state) => ({
    snackbar: state.snackbar,
    type: state.snackbar.type,
    message: state.snackbar.message,
  }),
  (state) => state
);
